import React from 'react';
import enhance from './enhance';
import ConditionalImage from 'components/shared/ConditionalImage';

const AlternativeDesign = ({ onClick, code, imageUrl, optionStyles }) => (
  <span>
    <ConditionalImage
      altText={code}
      imgUrl={imageUrl}
      className={optionStyles}
      onClick={onClick}
      onTouchStart={onClick}
    />
  </span>
);

export default enhance(AlternativeDesign);
